import React, { useState } from "react";
import "./SystemApplicationsEngineer.css";
import { Container } from "react-bootstrap";
import JobApplicationModal from "../../components/JobApplicationModal/JobApplicationModal";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../Context/LanguageContext";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../components/Loader/Loader";
import arrowRight from "../../assets/utility_images/arrow-right.svg";
import arrowRightWhite from "../../assets/utility_images/arrow-right-white.svg";

const SystemApplicationsEngineer = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Extract and process sections

  return (
    <div>
      <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
        <section className="privacy-policy-section">
          <div className="privacy-policy">
            {/* Render the first section separately */}

            <div className="policy-description">
              <div className="privacy-heading">JD402: UI/System Application Engineer (.NET)</div>
              <div className="job-description">
               We are looking for UI / System Application Engineer to develop modern desktop-based applications for Tube Inspection Systems. The role involves development of visualization platforms, CAD integration, reporting modules, and system-level application features.
              </div>

              <div className="value-header mt-4">
                Experience Level: 3 to 4 years
              </div>
            </div>

            {/* Render the other sections */}

            <div className="policy-description">
              <div className="value-header mt-4">Key Responsibilities</div>
              <div className="job-description">
                <ul>
                  <li>
                    Development of 3D viewer and visualization modules.
                  </li>
                  <li>Implementation of CAD overlay and alignment functionalities.</li>
                  <li>
                    Development of recipe management and configuration modules.
                  </li>
                  <li>
                    Development of reporting and analysis interfaces.
                  </li>
                  <li>
                    System integration and frontend-backend connectivity.
                  </li>
                  <li>
                    UI/UX enhancement for industrial inspection workflows.
                  </li>
                </ul>
              </div>
              <div className="value-header mt-4">
                Required Skills & Qualifications
              </div>
              <div className="job-description">
                <ul>
                  <li>
                    Strong experience in C# and WPF.
                  </li>
                  <li>
                    Experience in 3D Visualization and Graphics Programming.
                  </li>
                  <li>
                    Knowledge of CAD integration and overlay systems.
                  </li>
                  <li>
                    Understanding of desktop application architecture and UI development.
                  </li>
                  <li>
                    Experience in industrial or engineering software applications is preferred.
                  </li>
                  <li>
                    B.Tech / B.E in CS/IT/ECE with CGPA 7.5 +.
                  </li>
                </ul>
              </div>

              <button
                className="btn-job  d-flex justify-content-evenly align-items-center"
                onClick={handleShow} // Show modal on click
              >
                Apply
                <div className="hero-btn">
                  <img
                    className="hover-arrow"
                    src={arrowRight}
                    alt=""
                    loading="lazy"
                  />
                  <img
                    className="hover-arrow-white"
                    src={arrowRightWhite}
                    alt=""
                    loading="lazy"
                  />
                </div>
              </button>
            </div>
          </div>
        </section>
      </Container>
      <JobApplicationModal show={show} handleClose={handleClose} />
    </div>
  );
};

export default SystemApplicationsEngineer;
